;(function ($) {
    var oAddClass = $.fn.addClass;
    $.fn.addClass = function () {
        for (var i in arguments) {
            var arg = arguments[i];
            if ( !! (arg && arg.constructor && arg.call && arg.apply)) {
                setTimeout(arg.bind(this));
                delete arguments[i];
            }
        }
        return oAddClass.apply(this, arguments);
    }

})(jQuery);

var timeoutLeft,
	timeoutRight;

const app = {
	
	slideLeftToRight() {

		$('#shoes-details-left').find('.popup__shoes__points__inner').animate({
		    left: - ($('#shoes-details-left').find('.popup__shoes__points__inner img').outerWidth() - 250),
		    right: '',
	    }, 12000).delay(300).animate({
	     	right: '-20px',
	        left: ''
	    }, 12000, function () {
	      	timeoutLeft = setTimeout(app.slideLeftToRight(), 300);
	    });
	},

	slideRightToLeft() {
		$('#shoes-details-right').find('.popup__shoes__points__inner').animate({
		    left: '',
		    right: -($(window).outerWidth() + $('#shoes-details-right').find('.popup__shoes__points__inner img').outerWidth() + 895),
	    }, 12000).delay(300).animate({
	    	left: '-895px',
	    	right: ''
	    }, 12000, function () {
	        timeoutRight = setTimeout(app.slideRightToLeft(), 300);
	    });
	},

	shoesAnimations() {

		if ( $(window).outerWidth() < 992 ) {

			$(document).on('click', '#shoes-details-left img', function() {
				$('#shoes-details-left').find('.popup__shoes__points__inner').clearQueue();
				$('#shoes-details-left').find('.popup__shoes__points__inner').stop();
				$(this).addClass('paused');
			});

			$(document).on('click', '#shoes-details-left .point', function() {
				$('#shoes-details-left').find('.popup__shoes__points__inner').clearQueue();
				$('#shoes-details-left').find('.popup__shoes__points__inner').stop();
				$(this).addClass('paused');
			});

			$(document).on('click', '#shoes-details-left img.paused', function() {
				$(this).removeClass('paused');
				app.slideLeftToRight();
			});

			$(document).on('click', '#shoes-details-right img, #shoes-details-right .point', function() {
				$('#shoes-details-right').find('.popup__shoes__points__inner').clearQueue();
				$('#shoes-details-right').find('.popup__shoes__points__inner').stop();
				$(this).addClass('paused');
			});

			$(document).on('click', '#shoes-details-right .point', function() {
				$('#shoes-details-right').find('.popup__shoes__points__inner').clearQueue();
				$('#shoes-details-right').find('.popup__shoes__points__inner').stop();
				$(this).addClass('paused');
			});

			$(document).on('click', '#shoes-details-right img.paused', function() {
				$(this).removeClass('paused');
				app.slideRightToLeft();
			});
						
		}

	},	

	mainSectionHeightMobile() {

		if ( $(window).outerWidth() < 992 ) {

			let $footerHeight 		= $('.footer').outerHeight(),
				$mainSectionMobile 	= $('.section__main__mobile'),
				$sectionTop 		= $mainSectionMobile.find('.section__main__mobile__content__top'),
				$sectionBottom 		= $mainSectionMobile.find('.section__main__mobile__content__bottom');

			$mainSectionMobile.css({
				height: ( $(window).height() - $footerHeight - 55 ) + 'px'
			});

			$sectionTop.css({
				height: ( ($(window).height() - $footerHeight - 55 ) / 2 ) + 'px'
			});

			$sectionBottom.css({
				height: ( ($(window).height() - $footerHeight - 55 ) / 2 ) + 'px'
			});

		}

	},

	mainSectionHeightDesktop() {

		if ( $(window).outerWidth() > 992 ) {

			let $footerHeight 	= $('.footer').outerHeight(),
				$mainSection 	= $('.section__main');

			$mainSection.css({
				height: ( $(window).height() - $footerHeight - 140 ) + 'px'
			});

		}

	},

	showBoxElems(el) {

		setTimeout(function() {
			el.removeClass('show__more--open');
			el.parent('.inner__content--intro').addClass('open');
			el.parents('.section__main__content').find('.close__box').addClass('open');
			el.next('.details').addClass('open');

			el.parents('.section__main__content').find('.inner__content--info').addClass('open');
			el.parents('.section__main__content').find('.inner__content--team').addClass('open');

		}, 150);

	},

	hideBoxElems(el) {

		setTimeout(function() {
			el.parents('.section__main__content').find('.show__more').addClass('show__more--open');
			el.parents('.section__main__content').find('.inner__content--intro').removeClass('open');
			el.removeClass('open');
			el.parents('.section__main__content').find('.details').removeClass('open');

			el.parents('.section__main__content').find('.inner__content--info').removeClass('open');
			el.parents('.section__main__content').find('.inner__content--team').removeClass('open');
		}, 150);
	},

	expandSplittedBoxes() {

		let expandToRightButton 	= $('#expandToRight'),
			expandToLeftButton 		= $('#expandToLeft'),
			expandToTopButton 		= $('#expandToTop'),
			expandToBottomButton 	= $('#expandToBottom'),
			closeButton 			= $('.close__box'),
			leftBox 				= $('.section__main__left'),
			rightBox 				= $('.section__main__right');			

		expandToRightButton.on('click', (e) => {
			let $this 	= $(e.currentTarget);
			leftBox.addClass('open', app.showBoxElems( $this ) );
		});

		expandToLeftButton.on('click', (e) => {
			let $this 	= $(e.currentTarget);
			rightBox.addClass('open', app.showBoxElems( $this ));
		});

		expandToTopButton.on('click', (e) => {
			let $this 	= $(e.currentTarget);
			$('#influencer-top-mobile').fadeIn();
		});

		expandToBottomButton.on('click', (e) => {
			let $this 	= $(e.currentTarget);
			$('#influencer-bottom-mobile').fadeIn();
		});

		closeButton.on('click', (e) => {
			let $this 		= $(e.currentTarget),
				$position	= $this.attr('data-position');

			let $box 		= ( $position == 'left' ) ? leftBox : rightBox;

			$box.removeClass('open', app.hideBoxElems( $this ) );
		});

	},

	popupDynamicHeight() {

		let $footerHeight 	= $('.footer').outerHeight(),
			$popup 			= $('.popup');

		if ( $(window).outerWidth() > 992 ) {
			$popup.css({
				height: ( $(window).height() - $footerHeight ) + 'px'
			});
		} 		

	},

	popupBox() {

		$(document).on('click', '[data-popup]', (e) => {

			let $this 		= $(e.currentTarget),
				$popup 		= '#' + $this.attr('data-popup');

			if ( $($popup).length ) {
				$($popup).fadeIn(300, function() {

					if ( $(window).outerWidth() < 992 ) {

						if ( $('#shoes-details-right').is(':visible') ) {
							app.slideRightToLeft();
						}

						if ( $('#shoes-details-left').is(':visible') ) {
							app.slideLeftToRight();
						}

					}

				});
			}

		});

		$(document).on('click', '[data-close-popup]', (e) => {

			let $this 		= $(e.currentTarget),
				$popup 		= $this.parents('.popup');

			$popup.fadeOut();

			if ( $(window).outerWidth() < 992 ) {

				clearTimeout(timeoutLeft);
				$('#shoes-details-left').find('.popup__shoes__points__inner').stop(true, true);
				$('#shoes-details-left').find('.popup__shoes__points__inner').css({
					top: '-50px',
					right: '-20px',
					left: 'inherit'
				});

				clearTimeout(timeoutRight);
				$('#shoes-details-right').find('.popup__shoes__points__inner').stop(true, true);
				$('#shoes-details-right').find('.popup__shoes__points__inner').css({
					top: '-110px',
					right: 'inherit',
					left: '-895px'
				});

			}

		});

	},

	pointDescription() {

		if ( $(window).outerWidth() > 991 ) {
			$(document).on('click', '.point', (e) => {

				let $point 			= $(e.currentTarget),
					$pointContent 	= $point.find('.point__content');

				$('.point__content').hide();
				$pointContent.fadeToggle();

			});

			$(document).on('click', function (e) {

				if ( !$(e.target).parent().hasClass('point__pin') && !$(e.target).parent().hasClass('point__content')) {
					$('.point__content').fadeOut();
				} 

			});

		}

		if ( $(window).outerWidth() < 992 ) {

			$(document).on('click', '.point', (e) => {

				let $point 			= $(e.currentTarget),
					$target 		= $point.attr('data-point'),
					$boxContainer 	= $point.parents('.popup');

				$('.mobile__points__item').hide();
				$('#' + $target).fadeIn();

				$boxContainer.find('img').addClass('paused');


			});

			$(document).on('click', function (e) {

				let $boxContainerDetails = $(e.target).parents('.popup');

				if ( !$(e.target).parent().hasClass('point__pin') && !$(e.target).parent().hasClass('mobile__points__item')) {
					$('.mobile__points__item').fadeOut();
				} 


			});

		}

	},

	init() {
		app.mainSectionHeightDesktop();
		app.expandSplittedBoxes();
		app.popupBox();
		app.popupDynamicHeight();
		app.pointDescription();
		app.mainSectionHeightMobile();
		app.shoesAnimations();
	}

}

$(() => {

	app.init();

	$(window).resize(function() {
		app.mainSectionHeightDesktop();
		app.popupDynamicHeight();
		app.mainSectionHeightMobile();
	});

});